import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { Utils } from '../../../../../services';
import {
    build_email_preview_from,
    build_email_preview_reply_to,
    build_email_preview_bcc,
    resolve_email_layout_subject_preview,
} from '../../../../../services/emailLayoutPreviewUtils';

const EmailLayoutPreviewChrome = ({
    inEdition,
    setting,
    preview_context,
    lang,
    subject,
    layout_options,
}) => {
    const { t } = useTranslation();

    const subject_raw = Utils.localized_or_fallback(subject, lang, '');
    const resolved_subject = resolve_email_layout_subject_preview(subject_raw, preview_context, lang);

    const from_value = build_email_preview_from(setting, lang);
    const reply_to_value = build_email_preview_reply_to(setting, lang, layout_options, preview_context);
    const bcc_value = build_email_preview_bcc(setting, layout_options, preview_context, lang);

    const rows = [
        {
            key: 'from',
            label: t('layouts.email_preview.mail_from'),
            read_value: from_value,
        },
        {
            key: 'replyTo',
            label: t('layouts.email_preview.mail_reply_to'),
            read_value: reply_to_value,
            field: (
                <Field
                    component="input"
                    className="form-control form-control-sm"
                    type="email"
                    name="options[replyTo]"
                    placeholder={t('layouts.layout.options.replyTo_placeholder')}
                />
            ),
        },
        {
            key: 'bcc',
            label: t('layouts.email_preview.mail_bcc'),
            read_value: bcc_value,
            field: (
                <Field
                    component="input"
                    className="form-control form-control-sm"
                    type="email"
                    name="options[bcc]"
                    placeholder={t('layouts.layout.options.bcc_placeholder')}
                />
            ),
        },
        {
            key: 'subject',
            label: t('layouts.email_preview.mail_subject'),
            read_value: resolved_subject,
            field: (
                <Field
                    component="input"
                    className="form-control form-control-sm"
                    type="text"
                    name={`subject.${lang}`}
                    placeholder={t('layouts.layout.subject_placeholder')}
                />
            ),
        },
    ];

    return (
        <div className={`EmailLayoutPreviewChrome ${inEdition ? 'in-edition' : ''}`}>
            {rows.map(({ key, label, read_value, field }) => (
                <div key={key} className="chrome-row">
                    <span className="chrome-label">{label}</span>
                    <div className="chrome-value">
                        {inEdition && field ? field : (read_value || '—')}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default EmailLayoutPreviewChrome;
